export const mapSelectValues = item => {
  if (item.label && item.value) {
    return item
  }
  // considerar id como value y name como label
  if (item.id && item.name) {
    return { ...item, label: item.name, value: item.id }
  }
  // si no existen, preguntar si el objeto tiene una sola prop
  // en ese caso, usar esa prop como value y como label
  const ownProps = Object.getOwnPropertyNames(item)
  if (ownProps.length === 1) {
    return { label: item[ownProps[0]], value: item[ownProps[0]] }
  }
  if (typeof item === 'string') {
    return { label: item, value: item }
  }
  return { label: 'error', value: undefined }
}

export const queryOptionsLongCache = {
  staleTime: 1000 * 60 * 5
}

export const INTEGRATION_MELI_URL = '/integraciones/canales-de-venta';
export const INTEGRATION_MELI_URL_ACCOUNT_CREATION = '/integraciones/canales-de-venta/agregar-cuenta';
export const INTEGRATION_MELI_IDENTIFIER = 'integration-meli';
export const INTEGRATION_MELI_NOTIFICATION_URL = '/api/integrations/meli/notifications';
export const MELI_AUTH_URL = 'https://auth.mercadolibre.com.ar/authorization';
